import React from 'react';
import { IconProps } from './model/IconInterface';

const ChequeIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor', fill }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? color : 'none'}
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <rect x="2" y="6" width="20" height="12" rx="2" /><line x1="6" y1="14.5" x2="13" y2="14.5" /><line x1="16" y1="14.5" x2="18" y2="14.5" /><line x1="6" y1="10" x2="10" y2="10" />
    </svg>
  );
};

export default ChequeIcon;
